__turbopack_context__.v({
  "banner-beta-badge": "style-module-scss-module__kj7FQG__banner-beta-badge",
  "banner-content": "style-module-scss-module__kj7FQG__banner-content",
  "banner-icon": "style-module-scss-module__kj7FQG__banner-icon",
  "banner-text": "style-module-scss-module__kj7FQG__banner-text",
  "banner-title-row": "style-module-scss-module__kj7FQG__banner-title-row",
  "component": "style-module-scss-module__kj7FQG__component",
  "component-full-width": "style-module-scss-module__kj7FQG__component-full-width",
  "component-small-width": "style-module-scss-module__kj7FQG__component-small-width",
  "isAdvancedSearch": "style-module-scss-module__kj7FQG__isAdvancedSearch",
  "loading-spinner": "style-module-scss-module__kj7FQG__loading-spinner",
  "try-now-button": "style-module-scss-module__kj7FQG__try-now-button",
  "warning": "style-module-scss-module__kj7FQG__warning",
});
